import NotFound from "../components/NotFound"

import moment from 'moment';
import Container from '@mui/material/Container';
import PersonIcon from '@mui/icons-material/Person';
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { urls } from '../config.js'
import { Table, TableHead, TableRow, TableCell, TableBody, TextField, Card, Grid, CardActionArea, CardMedia, CardContent, Typography } from '@mui/material';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';

const persIcon = <PersonIcon fontSize="" />

function Chats() {
    const [loadingChats, setloadingChats] = useState(false);
    const [loadingClips, setloadingClips] = useState(false);
    const [pressed, setPressed] = useState(false);
    const [chatResponse, setChatResponse] = useState([]);
    const [clipResponse, setClipResponse] = useState([]);
    const [username, setUsername] = useState('');

    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
    };



const fetchData = async () => {
    setloadingClips(true)
    setloadingChats(true)

    const [chatsURL, clipsURL] = await Promise.allSettled([
        fetch(`${urls.chat}${username}`).then(response => response.json()),
        fetch(`${urls.insClips}${username}`).then(response => response.json())
    ]);

    const endpoint1Result = chatsURL.status === 'fulfilled' ? chatsURL.value : null;
    const endpoint2Result = clipsURL.status === 'fulfilled' ? clipsURL.value : null;


    // Process the results
    if (endpoint1Result) {
        setloadingChats(false)

        const formattedData1 = endpoint1Result.data.map(([url, timeInSeconds, authorName, message]) => ({
                url,
                timeInSeconds,
                authorName,
                message,
            }));
        setChatResponse(formattedData1);
    }

    if (endpoint2Result) {
        setloadingClips(false)
        const formattedData2 = endpoint2Result.clips.map(({ title, url, creator_name, thumbnail_url, created_at }) => ({
            title,
            url,
            creatorName: creator_name,
            thumbnail_url,
            created_at
        }));
    setClipResponse(formattedData2);
    }
};


    const handleKeyPress = async (event) => {
        if (event.key === 'Enter') {
            try {
                await fetchData();
                setPressed(true);
            } catch (error) {
                console.error(error);
            }
        }
    };

    return (
        <Container maxWidth="lg">
            <div className="title">
                <h2>Search for Chat</h2>
            </div>
            <div>
                <TextField
                    label="Enter username"
                    value={username}
                    onChange={handleUsernameChange}
                    onKeyDown={handleKeyPress}
                    variant="outlined"
                    size="small"
                />
                <Button variant="contained" onClick={() => { fetchData(); setPressed(true); }} disabled={!username || loadingChats} >
                    {loadingChats ? <CircularProgress size={24} /> : 'Search'}
                </Button>
            </div>
            {!(pressed) ? 
               ""
             : (
                <div>
                    {(loadingChats) ? 
                <div> <h3>Chats</h3> <Card> <CircularProgress /></Card> </div>
             : (    <div>
                    <h3>Chats</h3>
                    <Card>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>URL</TableCell>
                                <TableCell>Time (seconds)</TableCell>
                                <TableCell>Author Name</TableCell>
                                <TableCell>Message</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {chatResponse && chatResponse.map((message, index) => (
                                <TableRow key={index}>
                                    <TableCell><a href={message.url} target="_blank" style={{ color: 'white' }}>{message.url}</a></TableCell>
                                    <TableCell>{message.timeInSeconds}</TableCell>
                                    <TableCell>{message.authorName}</TableCell>
                                    <TableCell>{message.message}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    </Card>
                </div>
             )}
                                 {(loadingClips) ? 
                <div> <h3>Clips</h3> <Card> <CircularProgress /></Card> </div>
             : (    <div>
                    <h3>Clips</h3>
                    <Grid container spacing={{ xs: 1, md: 1 }} columns={{ xs: 1, sm: 10, md: 12 }} marginTop={2} marginBottom={2}>
                            {clipResponse && clipResponse.map((message, index) => (
                            
                                              <Grid xs={1} sm={4} md={3} key={index}>
                                              <item>
                                                <Card sx={{ maxWidth: 500 }} onClick={() => window.open(`${message.url}`, '_blank')}>
                                                  <CardActionArea>
                                                    <CardMedia
                                                      component="img"
                                                      image={message.thumbnail_url}
                                                    />
                                                    <CardContent>
                                                      <Typography gutterBottom variant="h5" component="div" id="videoTitle" style={{ fontSize: 17 }}>
                                                        {message.title}
                                                      </Typography>
                                                      <Typography variant="body2" color="text.secondary">
                                                        {persIcon}
                                                        {message.creatorName}
                                                        <br />
                                                        <AccessTimeFilledIcon fontSize="" />  {" "}
                                                        {moment(message.created_at).fromNow()}
                                                      </Typography>
                                                    </CardContent>
                                                  </CardActionArea>
                                                </Card>
                                              </item>
                                            </Grid>
                                           
                            ))}
  </Grid>
                </div>
             )}
                </div>
            )}
        </Container>
    );
}




export default Chats